import * as Vuex from 'vuex';
// eslint-disable-next-line import/no-cycle
import user from './modules/user';

export default Vuex.createStore({
  modules: {
    user, // 字典key
  },
});
